export default "__VITE_ASSET__BCE1w1Y0__"